import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-change-prog',
  templateUrl: './change-prog.component.html',
  styleUrls: ['./change-prog.component.css']
})
export class ChangeProgComponent implements OnInit {

  public menu_item_id = '9999';
  public edit_auth;

  private dp = [];
  displayedColumns = ['trip_number', 'trip_name', 'departure_date', 'arrival_date', 
    'visitors_number', 'registered_count', 'select'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'trip_name': '', 'trip_number': '', 'from_date': new Date(), 'to_date': new Date(), 
    'active': '0', 'invoice_date': new Date(), 'full_invoice_date': new Date() };

  invoice_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'customer_no': '', 'customer_name': '', 'calc_tax': '0', 'print_tax': '1', 'total': '', 'tax': '0',
    'discount': '0', 'rep_emp_no': '0', 'deliver_date': '0000-00-00', 'payment_date': '0000-00-00',
    'invoice_type': 'program', 'cond_list_id': '0', 'transport_fee': '0', 'received_by': '', 'is_paid': '0',
    'status': '1', 'cost_center': '0', 'sales_acct': '0', 'acct_number': '0', 'flag': 'new', 'key': 'invoice_id',
    'qutation_no': '', 'tax_acct': '0', 'trans_acct': '0', 'payment_method': '', 'comment': '',
    'meter_reading': '', 'worker': '', 'group_number': '', 'trip_id': '', 'pnr': '', 'pass_count': '',
    'bed_count': '0', 'seat_count': '0', 'agent_acct_number': '0', 'no': '0',
    'year': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'store_id': '0', 'total_no_tax': '0'
  };

  invoice_item_model = {
    'table_name': 'invoice_item', 'invoice_no': '', 'invoice_date': '0000-00-00',
    'sub_item_number': '0', 'sub_item_name': '', 'price': '0', 'unit_id': '0', 'count': '',
    'total_price': '0', 'tax_no': '', 'invoice_item_id': '0', 'tax_amount': '', 'type': 'p',
    'flag': 'new', 'key': 'invoice_item_id', 'discount': '0', 'stock_no': '0', 'store_id': '0',
    'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 'revenue_acct_no': '0'
  }

  inv_payment_model = {
    'table_name': 'inv_payment_method', 'invoice_no': '', 'inv_payment_method_id': '0', 'flag': 'new',
    'key': 'inv_payment_method_id', 'payment_type_id': '2', 'acct_number': '', 'amount': ''
  }

  group_model = {
    'table_name': 'trip_group', 'group_id': '0', 'invoice_no': '', 'head_id': '', 'member_id': '',
    'member_head_relation': '', 'is_active': '1', 'group_type': '', 'trip_arrival_date': '', 'trip_depart_date': '',
    'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': '0', 'price': '0', 'room_type_id': '',
    'flag': 'new', 'key': 'group_id', 'comment': ''
  };

  // model = { 'trip_id': '0', 'trip_status': 'active' };  'category_id': '', 

  // today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

  // search_prog = {
  //   'placeholder': 'اسم البرنامج/ رقم البرنامج/ تاريخ المغادرة / تاريخ العودة', 
  //   'class_name': 'longSearchField',
  //   'table_list': [{
  //     'table_name': '`trip`', 'selected_no': 'trip_id',
  //     'field_list': ['trip_name', 'trip_number', `departure_date`, `arrival_date`],
  //     'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
  //   }]
  // };

  trip_info = {};
  // has_cash_receipt = false;
  // toDelete = [];

  Search_Msg; Success_Msg; Error_Msg; Same_Prog_Msg; 
  Reg_Count_Msg; Reg_Count_Msg2; No_Depend_Msg; 
  No_Hotel_Msg; No_Room_Msg; Change_Prog_Msg;
  Cancel_Invoice_Msg; Ret_No_Msg; Change_Prog_Msg2;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ChangeProgComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Same_Prog_Msg').subscribe((res: string) => {
      this.Same_Prog_Msg = res;
    });

    translate.get('Reg_Count_Msg').subscribe((res: string) => {
      this.Reg_Count_Msg = res;
    }); 

    translate.get('Reg_Count_Msg2').subscribe((res: string) => {
      this.Reg_Count_Msg2 = res;
    }); 

    translate.get('No_Depend_Msg').subscribe((res: string) => {
      this.No_Depend_Msg = res;
    });

    translate.get('No_Hotel_Msg').subscribe((res: string) => {
      this.No_Hotel_Msg = res;
    });

    translate.get('No_Room_Msg').subscribe((res: string) => {
      this.No_Room_Msg = res;
    });
    
    translate.get('Change_Prog_Msg').subscribe((res: string) => {
      this.Change_Prog_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Change_Prog_Msg2').subscribe((res: string) => {
      this.Change_Prog_Msg2 = res;
    });
  }

  ngOnInit() {
    this.edit_auth = this.utils.getAuth('97', this.applicationConstants.EDIT_AUTH);

    this.model['invoice_date'] = new Date(this.dialog_data['full_invoice_date']);
    this.model['invoice_date'].setTime(this.model['invoice_date'].getTime() + (1 * 60 * 1000));
    if (new Date(this.model['invoice_date']) > new Date(this.applicationConstants.business_cycle.start_date))
      this.model['full_invoice_date'] = new Date(this.model['invoice_date']);
    else 
      this.model['full_invoice_date'] = new Date(this.applicationConstants.business_cycle.start_date);
    console.log(this.model['full_invoice_date']);
    // console.log("Data:");
    // console.log(this.dialog_data);
  }

  changeActivity() {
    this.model['active'] = ((document.getElementById('active') as HTMLInputElement).checked ? '1' : '0');
  }

  search() {
    if (this.model['trip_number'] == '' && this.model['trip_name'] == '' && 
      this.model['from_date'] == undefined && this.model['to_date'] == undefined && 
      this.model['active'] == '0') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getTripList' };

    if (this.model['trip_number'] != '')
      obj['trip_number'] = this.model['trip_number'];

    if (this.model['trip_name'] != '')
      obj['trip_name'] = this.model['trip_name'];
    
    // if (this.model['category_id'] != '')
    //   obj['category_id'] = this.model['category_id'];

    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

    if (this.model['active'] == '1') 
      obj['active'] = this.model['active'];
  
    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        // console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  // changeStatus() {
  //   if (this.model['trip_status'] == 'active')
  //     this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";
  //   else
  //     this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  // }

  // onChangeProg = function (search_result: object) {
  //   this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');

  //   let obj = { cmd: 'getTripList', 'trip_id': this.model['trip_id'] };
  //   this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
  //     .subscribe(data => {
  //       this.applicationConstants.appComp.hideBusyCursor();
  //       this.trip_info = data.data['list']['0'];
  //     });
  // }

  changeTrip(row) {
    let return_date;

    if (this.model['invoice_date'].getDate() != this.model['full_invoice_date'].getDate() ||  
      this.model['invoice_date'].getMonth() != this.model['full_invoice_date'].getMonth() || 
      this.model['invoice_date'].getFullYear() != this.model['full_invoice_date'].getFullYear()) {

      return_date = (this.model['invoice_date'].getFullYear() + "-" + (this.model['invoice_date'].getMonth() + 1) + "-" + 
        this.model['invoice_date'].getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() +
        ':' + new Date().getSeconds());
      
        this.model['invoice_date'] = new Date(return_date);
    }
    else 
      this.model['invoice_date'] = new Date(this.model['full_invoice_date']);
    
    console.log(this.model['invoice_date']);

    this.trip_info = row;
    let invoice_no = this.dialog_data['invoice_no'];
    let current_trip_id = this.dialog_data['trip_id'];
    let new_trip_id = this.trip_info['trip_id'];

    if (current_trip_id == new_trip_id) {
      alert(this.Same_Prog_Msg);
      return;
    }

    if (this.trip_info['complete']) {
      alert(this.Reg_Count_Msg);
      return;
    }

    let obj;

    // get contract detail
    obj = { cmd: 'getContractDetail', invoice_no: invoice_no };

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          //------------------------ Trip Group ------------------------//
          let trip_group = result['trip_group'];
          let pass_count = Number(this.dialog_data['pass_count']);
          let depend_added = true;
          
          if (trip_group.length > 0) {

            let arrival_date = new Date(this.trip_info['arrival_date']);
            let birthdate, timeDiff;
            pass_count = 0;
  
            trip_group.forEach(element => {
              birthdate = new Date(element.date_of_birth);
              timeDiff = Math.abs(arrival_date.getTime() - birthdate.getTime());
              element.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
  
              if(element.age >= 2)
                pass_count += 1;
            });
          }
          
          if (trip_group.length == 1 && Number(this.dialog_data['pass_count']) > 1) 
            depend_added = false;
          

          // check if there is available seats for group
          if (pass_count > (this.trip_info['visitors_number'] - this.trip_info['registered_count'])) 
            alert(this.Reg_Count_Msg2);
          else {
            if (confirm(this.Change_Prog_Msg)) {
              let index = 0;
              let total = 0, discount = 0, tax = 0, taxable_price = 0, price_w_tax = 0;
              // this.toDelete = [];

              //------------------------ Invoice ------------------------//
              let invoice_info = result['invoice_info'];

              //------------------------ Invoice Item ------------------------//
              let invoice_item = result['invoice_item'];

              //------------------------ Payment Method ------------------------//
              let inv_payment_method;
              if (result['payment_method'].length > 0) 
                inv_payment_method = result['payment_method'][0];


              //------------------------ Reg on Hotel ------------------------//
              let reg_on_hotel = result['reg_on_hotel'];

              //------------------------ Reg on Visa ------------------------//
              let reg_on_visa = result['reg_on_visa'];

              //------------------------ Reg on Bus ------------------------//
              // let reg_on_bus = result['reg_on_bus'];

              // check if there is cash receipt for this invoice
              // this.has_cash_receipt = result['has_cash_receipt'];

              // get new trip detail
              obj = { cmd: 'getTripDetail', trip_id: new_trip_id };

              this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'error') 
                    alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

                  else if (data.status['type'] == 'success') {
                    let result = data.status['msg'][0];

                    // get trip detail
                    this.trip_info = result['trip_info'];

                    // get tax detail
                    let trip_tax;
                    if (this.trip_info['tax_no'] != '' && this.trip_info['tax_no'] != '0') 
                      trip_tax = result['trip_tax'];

                    ///------------------------ Trip Country, City & Hotel ------------------------//
                    let trip_country = result['country_list'];
                    let trip_city = result['city_list'];
                    let trip_city_hotel = result['hotel_list'];

                    //------------------------ Trip Bus ------------------------//
                    // let trip_bus = result['bus_list'];


                    //------------------------ Trip Price ------------------------//
                    let trip_room_price, trip_age_price;

                    if (this.trip_info['price_type'] == 'room') 
                      trip_room_price = result['room_list'];
                    else if (this.trip_info['price_type'] == 'age') 
                      trip_age_price = result['age_list'];

                    let new_reg_on_hotel = [];
                    let new_trip_group = [];
                    let new_reg_on_visa = [];
                    let existed = false;
                    let amount = '';

                    // if there is dependants but not added (price specified by room type)
                    if (pass_count > 1 && !depend_added && this.trip_info['price_type'] == 'room') {

                      if (reg_on_hotel.length > 0) {
                        reg_on_hotel.forEach(element => {
                          existed = false;

                          for (index = 0; index < trip_room_price.length; index++) {
                            if (element.room_type_id == trip_room_price[index].room_type_id) {

                              if (Number(trip_room_price[index].bed_num) > 0)
                                element.amount = String(Number(trip_room_price[index].room_price) * Number(trip_room_price[index].bed_num) * Number(element.count));
                              else 
                                element.amount = String(Number(trip_room_price[index].room_price) * Number(element.count));

                              total += Number(element.amount);
                              new_reg_on_hotel.push({ 'table_name': 'reg_on_hotel', 'reg_id': '0', 
                                'invoice_no': this.invoice_model['invoice_no'],
                                'room_type_id': element.room_type_id, 'flag': 'new', 'key': 'reg_id',
                                'count': element.count, 'bed_num': trip_room_price[index].bed_num, 
                                'comment': element.comment, 'amount': element.amount,
                                'city_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].city_id : (trip_city.length > 0 ? trip_city[0].city_id : '0')), 
                                'hotel_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].hotel_id : '0'),
                                'room_price': trip_room_price[index].room_price, 
                                'room_cost': trip_room_price[index].room_cost, 'package': element.package, 'tax_no': element.tax_no,
                                'tax_type': element.tax_type, 'room_tax_amount': trip_room_price[index].room_tax_amount, 
                                'checkin_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].arrival_date : (trip_city.length > 0 ? trip_city[0].arrival_date : this.trip_info['departure_date'])), 
                                'checkout_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].depart_date : (trip_city.length > 0 ? trip_city[0].depart_date : this.trip_info['arrival_date'])), 
                                'room_type': trip_room_price[index].room_type });
                              existed = true;
                              break;
                            }
                          }

                          if (!existed) {
                            if (Number(trip_room_price[0].bed_num) > 0)
                              element.amount = String(Number(trip_room_price[0].room_price) * Number(trip_room_price[0].bed_num) * Number(element.count));
                            else 
                              element.amount = String(Number(trip_room_price[0].room_price) * Number(element.count));

                            total += Number(element.amount);
                            new_reg_on_hotel.push({ 'table_name': 'reg_on_hotel', 'reg_id': '0', 
                              'invoice_no': this.invoice_model['invoice_no'],
                              'room_type_id': trip_room_price[0].room_type_id, 'flag': 'new', 'key': 'reg_id',
                              'count': element.count, 'bed_num': trip_room_price[0].bed_num, 
                              'comment': element.comment, 'amount': element.amount,
                              'city_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].city_id : (trip_city.length > 0 ? trip_city[0].city_id : '0')), 
                              'hotel_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].hotel_id : '0'),
                              'room_price': trip_room_price[0].room_price, 
                              'room_cost': trip_room_price[0].room_cost, 'package': '', 'tax_no': '0',
                              'tax_type': '', 'room_tax_amount': trip_room_price[0].room_tax_amount, 
                              'checkin_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].arrival_date : (trip_city.length > 0 ? trip_city[0].arrival_date : this.trip_info['departure_date'])), 
                              'checkout_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].depart_date : (trip_city.length > 0 ? trip_city[0].depart_date : this.trip_info['arrival_date'])), 
                              'room_type': trip_room_price[0].room_type });
                          }
                        });
                      }
                      else {
                        if (Number(trip_room_price[0].bed_num) > 0)
                          amount = String(Number(trip_room_price[0].room_price) * Number(trip_room_price[0].bed_num) * 1);
                        else 
                          amount = String(Number(trip_room_price[0].room_price) * 1);

                        total += Number(amount);
                        new_reg_on_hotel.push({ 'table_name': 'reg_on_hotel', 'reg_id': '0', 
                          'invoice_no': this.invoice_model['invoice_no'],
                          'room_type_id': trip_room_price[0].room_type_id, 'flag': 'new', 'key': 'reg_id',
                          'count': '1', 'bed_num': trip_room_price[0].bed_num, 'comment': '', 'amount': amount,
                          'city_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].city_id : (trip_city.length > 0 ? trip_city[0].city_id : '0')), 
                          'hotel_id': (trip_city_hotel.length > 0 ? trip_city_hotel[0].hotel_id : '0'),
                          'room_price': trip_room_price[0].room_price, 
                          'room_cost': trip_room_price[0].room_cost, 'package': '', 'tax_no': '0',
                          'tax_type': '', 'room_tax_amount': trip_room_price[0].room_tax_amount, 
                          'checkin_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].arrival_date : (trip_city.length > 0 ? trip_city[0].arrival_date : this.trip_info['departure_date'])), 
                          'checkout_date': (trip_city_hotel.length > 0 ? trip_city_hotel[0].depart_date : (trip_city.length > 0 ? trip_city[0].depart_date : this.trip_info['arrival_date'])), 
                          'room_type': trip_room_price[0].room_type });
                      }
                    }
                    else {
                      let price = 0;
                      if (this.trip_info['price_type'] == 'room') {

                        trip_group.forEach(element => {
                          existed = false;

                          if (this.dialog_data['price_type'] == 'room') {
                            // check if room typd is existed
                            for (index = 0; index < trip_room_price.length; index++) {

                              if (element.room_type_id == trip_room_price[index].room_type_id) {

                                total += Number(trip_room_price[index].room_price);
                                price = Number(trip_room_price[index].room_price);

                                if (Number(element.visa_price) > 0) {
                                  total += Number(this.trip_info['visa_price']);
                                  price += Number(this.trip_info['visa_price']);
                                }
                            
                                if (Number(element.food_price) > 0) {
                                  total += Number(this.trip_info['food_price']);
                                  price += Number(this.trip_info['food_price']);
                                }
                                  
                                new_trip_group.push({ 'table_name': 'trip_group', 'group_id': '0', 
                                  'invoice_no': this.invoice_model['invoice_no'], 'head_id': element.head_id, 
                                  'member_id': element.member_id, 'member_head_relation': element.member_head_relation, 
                                  'is_active': '1', 'group_type': '', 'trip_arrival_date': this.trip_info['arrival_date'], 
                                  'trip_depart_date': this.trip_info['departure_date'], 'eticket': '',
                                  'ticket_status': '0', 'ticket_count': element.ticket_count, 
                                  'bed_count': '0', 'price': price.toFixed(2), 'flag': 'new', 
                                  'key': 'group_id', 'room_type_id': element.room_type_id, 
                                  'comment': element.comment, 'customer_name': element.customer_name,
                                  'visa_price': (Number(element.visa_price) > 0 ? this.trip_info['visa_price'] : '0'), 
                                  'food_price': (Number(element.food_price) > 0 ? this.trip_info['food_price'] : '0') });

                                existed = true;
                                break;
                              }
                            }
                          }
                          
                          if (!existed) {
                            total += Number(trip_room_price[0].room_price);
                            price = Number(trip_room_price[0].room_price);
                        
                            if (Number(element.visa_price) > 0) {
                              total += Number(this.trip_info['visa_price']);
                              price += Number(this.trip_info['visa_price']);
                            }
                        
                            if (Number(element.food_price) > 0) {
                              total += Number(this.trip_info['food_price']);
                              price += Number(this.trip_info['food_price']);
                            }

                            new_trip_group.push({ 'table_name': 'trip_group', 'group_id': '0', 
                              'invoice_no': this.invoice_model['invoice_no'], 'head_id': element.head_id, 
                              'member_id': element.member_id, 'member_head_relation': element.member_head_relation, 
                              'is_active': '1', 'group_type': '', 'trip_arrival_date': this.trip_info['arrival_date'], 
                              'trip_depart_date': this.trip_info['departure_date'], 'eticket': '',
                              'ticket_status': '0', 'ticket_count': element.ticket_count, 
                              'bed_count': '0', 'price': price.toFixed(2), 'flag': 'new', 
                              'key': 'group_id', 'room_type_id': trip_room_price[0].room_type_id, 
                              'comment': element.comment, 'customer_name': element.customer_name, 
                              'visa_price': (Number(element.visa_price) > 0 ? this.trip_info['visa_price'] : '0'), 
                              'food_price': (Number(element.food_price) > 0 ? this.trip_info['food_price'] : '0') });
                          }
                          
                        });
                      }
                      else if (this.trip_info['price_type'] == 'age') {

                        trip_group.forEach(element => {
                          existed = false;

                          // check if room typd is existed
                          for (index = 0; index < trip_age_price.length; index++) {

                            if (element.age >= Number(trip_age_price[index].period_from) && element.age < Number(trip_age_price[index].period_to)) {

                              total += Number((this.dialog_data['price_type'] == 'room' || element.bed_count == '1' ? trip_age_price[index].price_bed : trip_age_price[index].price_no_bed));
                              price = Number((this.dialog_data['price_type'] == 'room' || element.bed_count == '1' ? trip_age_price[index].price_bed : trip_age_price[index].price_no_bed));

                              if (Number(element.visa_price) > 0) {
                                total += Number(this.trip_info['visa_price']);
                                price += Number(this.trip_info['visa_price']);
                              }
                          
                              if (Number(element.food_price) > 0) {
                                total += Number(this.trip_info['food_price']);
                                price += Number(this.trip_info['food_price']);
                              }

                              new_trip_group.push({ 'table_name': 'trip_group', 'group_id': '0', 
                                'invoice_no': this.invoice_model['invoice_no'], 'head_id': element.head_id, 
                                'member_id': element.member_id, 'member_head_relation': element.member_head_relation, 
                                'is_active': '1', 'group_type': '', 'trip_arrival_date': this.trip_info['arrival_date'], 
                                'trip_depart_date': this.trip_info['departure_date'], 'eticket': '',
                                'ticket_status': '0', 'ticket_count': element.ticket_count, 
                                'bed_count': (this.dialog_data['price_type'] == 'room' ? '1' : element.bed_count), 
                                'price': price.toFixed(2), 'flag': 'new', 'key': 'group_id', 
                                'room_type_id': '0', 'comment': element.comment, 'customer_name': element.customer_name, 
                                'visa_price': (Number(element.visa_price) > 0 ? this.trip_info['visa_price'] : '0'), 
                                'food_price': (Number(element.food_price) > 0 ? this.trip_info['food_price'] : '0') });

                              existed = true;
                              break;
                            }
                          }

                          if (!existed) {
                            total += Number((this.dialog_data['price_type'] == 'room' || element.bed_count == '1' ? trip_age_price[0].price_bed : trip_age_price[0].price_no_bed));
                            price = Number((this.dialog_data['price_type'] == 'room' || element.bed_count == '1' ? trip_age_price[0].price_bed : trip_age_price[0].price_no_bed));

                            if (Number(element.visa_price) > 0) {
                              total += Number(this.trip_info['visa_price']);
                              price += Number(this.trip_info['visa_price']);
                            }
                        
                            if (Number(element.food_price) > 0) {
                              total += Number(this.trip_info['food_price']);
                              price += Number(this.trip_info['food_price']);
                            }

                            new_trip_group.push({ 'table_name': 'trip_group', 'group_id': '0', 
                              'invoice_no': this.invoice_model['invoice_no'], 'head_id': element.head_id, 
                              'member_id': element.member_id, 'member_head_relation': element.member_head_relation, 
                              'is_active': '1', 'group_type': '', 'trip_arrival_date': this.trip_info['arrival_date'], 
                              'trip_depart_date': this.trip_info['departure_date'], 'eticket': '',
                              'ticket_status': '0', 'ticket_count': element.ticket_count, 
                              'bed_count': (this.dialog_data['price_type'] == 'room' ? '1' : element.bed_count), 
                              'price': price.toFixed(2), 'flag': 'new', 'key': 'group_id', 'room_type_id': '0', 
                              'comment': element.comment, 'customer_name': element.customer_name, 
                              'visa_price': (Number(element.visa_price) > 0 ? this.trip_info['visa_price'] : '0'), 
                              'food_price': (Number(element.food_price) > 0 ? this.trip_info['food_price'] : '0') });
                          }
                        });
                      }

                      if (reg_on_hotel.length > 0) {
                        reg_on_hotel.forEach(element => {
                          existed = false;

                          for (index = 0; index < trip_city_hotel.length; index++) {
                            if (element.hotel_id == trip_city_hotel[index].hotel_id) {

                              new_reg_on_hotel.push({ 'table_name': 'reg_on_hotel', 'reg_id': '0', 
                                'invoice_no': this.invoice_model['invoice_no'],
                                'room_type_id': element.room_type_id, 'flag': 'new', 'key': 'reg_id',
                                'count': element.count, 'bed_num': '0', 'comment': element.comment, 'amount': element.amount,
                                'city_id': trip_city_hotel[index].city_id, 'hotel_id': trip_city_hotel[index].hotel_id,
                                'room_price': element.room_price, 'room_cost': element.room_cost, 
                                'package': element.package, 'tax_no': element.tax_no,
                                'tax_type': element.tax_type, 'room_tax_amount': element.room_tax_amount, 
                                'checkin_date': trip_city_hotel[index].arrival_date, 
                                'checkout_date': trip_city_hotel[index].depart_date, 'room_type': '' });
                              existed = true;
                              break;
                            }
                          }

                          if (!existed) {
                      
                            new_reg_on_hotel.push({ 'table_name': 'reg_on_hotel', 'reg_id': '0', 
                              'invoice_no': this.invoice_model['invoice_no'],
                              'room_type_id': element.room_type_id, 'flag': 'new', 'key': 'reg_id',
                              'count': element.count, 'bed_num': '0', 
                              'comment': element.comment, 'amount': element.amount,
                              'city_id': trip_city_hotel[0].city_id, 'hotel_id': trip_city_hotel[0].hotel_id,
                              'room_price': element.room_price, 
                              'room_cost': element.room_cost, 'package': '', 'tax_no': '0',
                              'tax_type': '', 'room_tax_amount': element.room_tax_amount, 
                              'checkin_date': trip_city_hotel[0].arrival_date, 
                              'checkout_date': trip_city_hotel[0].depart_date, 'room_type': '' });
                          }
                        });
                      }

                      if (reg_on_visa.length > 0) {
                        reg_on_visa.forEach(element => {
                          existed = false;

                          for (index = 0; index < trip_country.length; index++) {
                            if (element.country_id == trip_country[index].country_id) {

                              new_reg_on_visa.push({ 'table_name': 'reg_on_visa', 'reg_visa_id': '0', 
                                'invoice_no': this.invoice_model['invoice_no'],
                                'visa_tax_amount': element.visa_tax_amount, 'country_id': element.country_id,
                                'visa_count': element.visa_count, 'visa_price': this.trip_info['visa_price'], 
                                'visa_cost': element.visa_cost, 'tax_no': element.tax_no, 
                                'tax_type': element.tax_type, 'flag': 'new', 'key': 'reg_visa_id', 
                                'comment': element.comment });
                              existed = true;
                              break;
                            }
                          }

                          if (!existed) {
                      
                            new_reg_on_visa.push({ 'table_name': 'reg_on_visa', 'reg_visa_id': '0', 
                              'invoice_no': this.invoice_model['invoice_no'],
                              'visa_tax_amount': element.visa_tax_amount, 'country_id': trip_country[0].country_id,
                              'visa_count': element.visa_count, 'visa_price': this.trip_info['visa_price'], 
                              'visa_cost': element.visa_cost, 'tax_no': element.tax_no, 
                              'tax_type': element.tax_type, 'flag': 'new', 'key': 'reg_visa_id', 
                              'comment': element.comment });
                          }
                        });
                      }
                    }

                    if (invoice_info['bed_count']) 
                      total += Number(this.trip_info['bed_price']) * Number(invoice_info['bed_count']);
          
                    if (invoice_info['seat_count']) 
                      total += Number(this.trip_info['seat_price']) * Number(invoice_info['seat_count']);
                    
                    invoice_item.forEach(element => {
                      if (element.type == 'pa') 
                        total += Number(element.price);
                    });

                    let values = [];

                    // fill values to add the new invoice/contract

                    //------------------------ Invoice ------------------------//  
                    let invoice_date = this.model['invoice_date'].getFullYear() + "-" + (this.model['invoice_date'].getMonth() + 1) + "-" +
                      this.model['invoice_date'].getDate() + ' ' + this.model['invoice_date'].getHours() + 
                      ':' + this.model['invoice_date'].getMinutes() + ':' + this.model['invoice_date'].getSeconds();

                    this.invoice_model['invoice_date'] = invoice_date;
                    this.invoice_model['deliver_date'] = invoice_date;
                    this.invoice_model['payment_date'] = invoice_date;
                    
                    this.invoice_model['customer_no'] = invoice_info['customer_no'];
                    this.invoice_model['payment_method'] = invoice_info['payment_method']; 
                    this.invoice_model['is_paid'] = invoice_info['is_paid'];
                    this.invoice_model['sales_acct'] = invoice_info['sales_acct']; 
                    this.invoice_model['acct_number'] = invoice_info['acct_number'];
                    this.invoice_model['cond_list_id'] = invoice_info['cond_list_id']; 
                    this.invoice_model['comment'] = invoice_info['comment']; 
                    this.invoice_model['trip_id'] = new_trip_id; 
                    this.invoice_model['pass_count'] = invoice_info['pass_count']; 
                    this.invoice_model['bed_count'] = invoice_info['bed_count'];
                    this.invoice_model['seat_count'] = invoice_info['seat_count'];
                    this.invoice_model['store_id'] = invoice_info['store_id'];

                    this.invoice_model['total'] = total.toFixed(2);
                    this.invoice_model['discount'] = invoice_info['discount'];

                    if (Number(this.invoice_model['discount']) > total)
                      this.invoice_model['discount'] = this.invoice_model['total'];

                    discount  = Number(this.invoice_model['discount']);

                    // calculate tax
                    if (this.trip_info['tax_type'] == 'all_price') {
                      if (trip_tax['tax_perc'] != '0')
                        tax = (total - Number(this.invoice_model['discount'])) * (Number(trip_tax['tax_perc']) / 100);
                      else
                        tax = trip_tax['tax_amount'];

                      this.invoice_model['tax'] = tax.toFixed(2);
                    }
                    else if (this.trip_info['tax_type'] == 'part_price') {
                      taxable_price = (this.trip_info['price_for_tax'] == '' ? 0 : Number(this.trip_info['price_for_tax']));
                      
                      if (pass_count > 1 && !depend_added) {
                        let bed_count = 0;
                        new_reg_on_hotel.forEach(element => {
                
                          if (Number(element.bed_num) > 0) 
                            bed_count += Number(element.count) * Number(element.bed_num);
                        });
                
                        price_w_tax = taxable_price * bed_count;
                      }
                      else 
                      price_w_tax = taxable_price * pass_count;
                     
                      if (trip_tax['tax_perc'] != '0') {
                        let part_tax_amount = 0;
                        part_tax_amount = (taxable_price * (Number(trip_tax['tax_perc']) / 100));
                        tax = part_tax_amount * pass_count;
                        this.invoice_model['total_no_tax'] = (total - price_w_tax).toFixed(2);
                      }
                      else 
                        tax = Number(trip_tax['tax_amount']);

                      this.invoice_model['tax'] = tax.toFixed(2);
                    }

                    if (Number(this.invoice_model['tax']) > 0) {
                      this.invoice_model['tax_acct'] = String(trip_tax['acct_number']);
                      this.invoice_model['calc_tax'] = '1';
                    }
                    values.push(this.invoice_model);

                    //------------------------ Payment Method ------------------------//
                    this.inv_payment_model['invoice_no'] = this.invoice_model['invoice_no'];
                    this.inv_payment_model['acct_number'] = this.invoice_model['customer_no'];
                    this.inv_payment_model['amount'] = (total - discount + tax).toFixed(2);

                    values.push(this.inv_payment_model);

                    let total_price = 0, tax_amount = 0;
                    let sub_item_name, item_discount;

                    //------------------------ Invoice Item and Traveler/ Trip Group ------------------------//
                    if (pass_count > 1 && !depend_added && this.trip_info['price_type'] == 'room') {
                      let bed_count = 0, taxable_amount = 0, room_total_amount = 0;

                      new_reg_on_hotel.forEach(element => {
                        sub_item_name = 'غرفة ' + element.room_type + ' على الرحلة ' + this.trip_info['trip_name'] +
                          " (" + this.trip_info['trip_number'] + ")";
                
                        tax_amount = 0;
                        item_discount = 0;
                    
                        total_price = Number(element.count) * Number(element.room_price);
                        bed_count = Number(element.count);
                
                        if (Number(element.bed_num) > 0) {
                          total_price *= Number(element.bed_num);
                          bed_count *= Number(element.bed_num);
                        }
                        room_total_amount += total_price;
                
                        if (this.trip_info['tax_type'] != 'part_price') {
                          if (discount > 0) {
                            if (total_price >= discount)
                              item_discount = discount;
                            else 
                              item_discount = total_price;
                          }
                        }
                
                        if (this.trip_info['tax_type'] == 'all_price') {
                          if (trip_tax['tax_perc'] != '0') 
                            tax_amount = (total_price - item_discount) * (Number(trip_tax['tax_perc']) / 100);
                          else  
                            tax_amount = Number(trip_tax['tax_amount']);
                        }
                
                        values.push({
                          'table_name': 'reg_on_hotel', 'reg_id': element.reg_id, 'invoice_no': this.invoice_model['invoice_no'],
                          'room_type_id': element.room_type_id, 'flag': element.flag, 'key': 'reg_id',
                          'count': element.count, 'comment': element.comment,'city_id': element.city_id,
                           'hotel_id': element.hotel_id, 'room_price': element.room_price, 
                           'room_cost': element.room_cost, 'package': '', 'tax_no': '0', 'tax_type': '', 
                           'room_tax_amount': element.room_tax_amount, 'checkin_date': element.checkin_date, 
                           'checkout_date': element.checkout_date
                        });
                
                        if (this.trip_info['tax_type'] == 'part_price') {
                
                          // calculate tax on part of price
                          taxable_amount = bed_count * taxable_price;
                          if (trip_tax['tax_perc'] != '0') 
                            tax_amount = taxable_amount * (Number(trip_tax['tax_perc']) / 100);
                          else 
                            tax_amount = Number(trip_tax['tax_amount']);
                
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
                            'sub_item_name': 'رسوم حجز غرفة ' + element.room_type + ' على الرحلة ' + 
                            this.trip_info['trip_name'] + " (" + this.trip_info['trip_number'] + ")",
                            'price': taxable_price, 'unit_id': '0', 'count': bed_count, 
                            'total_price': taxable_amount.toFixed(2), 'tax_no': this.trip_info['tax_no'], 
                            'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
                            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
                            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
                            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                          
                          // calculate no tax price
                          total_price = total_price - taxable_amount;
                          tax_amount = 0;
                
                          if (discount > 0) {
                            if (total_price >= discount)
                              item_discount = discount;
                            else 
                              item_discount = total_price;
                          }
                
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 'sub_item_name': sub_item_name,
                            'price': (element.room_price - taxable_price).toFixed(2), 
                            'unit_id': '0', 'count': bed_count, 'total_price': total_price.toFixed(2),
                            'tax_no': '', 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
                            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
                            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
                            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                        }
                        else {
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
                            'sub_item_name': sub_item_name, 'price': element.room_price, 'unit_id': '0', 
                            'count':bed_count, 'total_price': total_price.toFixed(2), 
                            'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
                            'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2), 'type': 'p', 'flag': 'new', 
                            'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 'stock_no': '0', 
                            'store_id': this.invoice_model['store_id'],
                            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '',
                            'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                        }
                
                        if (discount > 0) 
                          discount -= item_discount;
                      });

                      let element = trip_group[0];

                      values.push({
                        'table_name': 'trip_group', 'group_id': '0', 'invoice_no': this.invoice_model['invoice_no'],
                        'head_id': element.head_id, 'member_id': element.member_id,
                        'member_head_relation': element.member_head_relation, 'is_active': '1', 'group_type': '',
                        'trip_arrival_date': this.trip_info['arrival_date'], 'trip_depart_date': this.trip_info['departure_date'],
                        'eticket': '', 'ticket_status': '0', 'ticket_count': '0', 'bed_count': element.bed_count,
                        'price': room_total_amount.toFixed(2), 'flag': 'new', 'key': 'group_id', 'room_type_id': '',
                        'comment': element.comment, 'visa_price': '0', 'food_price': element.food_price
                      });
                    }
                    else {
                      index = 0;
                      new_trip_group.forEach(element => {
                        sub_item_name = 'تسجيل ' + element.customer_name + ' على الرحلة ' + this.trip_info['trip_name'] +
                          " (" + this.trip_info['trip_number'] + ")";
                
                        tax_amount = 0;
                        item_discount = 0;
                        total_price = Number(element.price);
                        if (this.trip_info['tax_type'] != 'part_price') {
                          if (discount > 0) {
                            if (total_price >= discount)
                              item_discount = discount;
                            else 
                              item_discount = total_price;
                          }
                        }
                
                        if (this.trip_info['tax_type'] == 'all_price') {
                          if (trip_tax['tax_perc'] != '0') 
                            tax_amount = (total_price - item_discount) * (Number(trip_tax['tax_perc']) / 100);
                          else 
                            tax_amount = Number(trip_tax['tax_amount']);
                        }
                
                        values.push({
                          'table_name': 'trip_group', 'group_id': element.group_id, 'invoice_no': this.invoice_model['invoice_no'],
                          'head_id': element.head_id, 'member_id': element.member_id,
                          'member_head_relation': element.member_head_relation, 'is_active': '1', 'group_type': '',
                          'trip_arrival_date': element.trip_arrival_date, 'trip_depart_date': element.trip_depart_date, 
                          'eticket': '', 'ticket_status': '0', 'ticket_count': element.ticket_count, 
                          'bed_count': element.bed_count, 'price': element.price, 'flag': element.flag, 
                          'key': 'group_id', 'room_type_id': element.room_type_id, 'comment': element.comment,
                          'visa_price': element.visa_price, 'food_price': element.food_price
                        });
                
                        if (this.trip_info['tax_type'] == 'part_price') {
                
                          // calculate tax on part of price
                          total_price = taxable_price;
                          if (trip_tax['tax_perc'] != '0') 
                            tax_amount = total_price * (Number(trip_tax['tax_perc']) / 100);
                          else 
                            tax_amount = Number(trip_tax['tax_amount']);
                
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
                            'sub_item_name': 'رسوم تسجيل ' + element.customer_name + ' على الرحلة ' + 
                            this.trip_info['trip_name'] + " (" + this.trip_info['trip_number'] + ")",
                            'price': total_price.toFixed(2), 'unit_id': '0', 'count': '1', 'total_price': total_price.toFixed(2),
                            'tax_no': this.trip_info['tax_no'], 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
                            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
                            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
                            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                          
                          // calculate no tax price
                          total_price = Number(element.price) - total_price;
                          tax_amount = 0;
                
                          if (discount > 0) {
                            if (total_price >= discount)
                              item_discount = discount;
                            else 
                              item_discount = total_price;
                          }
                
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 'sub_item_name': sub_item_name,
                            'price': total_price.toFixed(2), 'unit_id': '0', 'count': '1', 'total_price': total_price.toFixed(2),
                            'tax_no': '', 'invoice_item_id': '0', 'tax_amount': tax_amount.toFixed(2),
                            'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 'discount': item_discount.toFixed(2), 
                            'stock_no': '0', 'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 
                            'primary_quantity': '0', 'comment': '', 'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                        }
                        else {
                          values.push({
                            'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                            'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0', 
                            'sub_item_name': sub_item_name, 'price': total_price.toFixed(2), 'unit_id': '0', 
                            'count': '1', 'total_price': total_price.toFixed(2),
                            'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 'invoice_item_id': '0', 
                            'tax_amount': tax_amount.toFixed(2), 'type': 'p', 'flag': 'new', 'key': 'invoice_item_id', 
                            'discount': item_discount.toFixed(2), 'stock_no': '0', 'store_id': this.invoice_model['store_id'], 
                            'primary_sub_item_number': '', 'primary_quantity': '0', 'comment': '', 
                            'revenue_acct_no': this.invoice_model['sales_acct']
                          });
                        }
                
                        if (discount > 0) 
                          discount -= item_discount;
                
                        index++;
                      });

                      new_reg_on_hotel.forEach(element => {
                        values.push({
                          'table_name': 'reg_on_hotel', 'reg_id': element.reg_id, 'invoice_no': this.invoice_model['invoice_no'],
                          'room_type_id': element.room_type_id, 'flag': element.flag, 'key': 'reg_id',
                          'count': element.count, 'comment': element.comment, 'city_id': element.city_id, 
                          'hotel_id': element.hotel_id, 'room_price': element.room_price, 
                          'room_cost': element.room_cost, 'package': '', 'tax_no': '0',
                          'tax_type': '', 'room_tax_amount': element.room_tax_amount, 
                          'checkin_date': element.checkin_date, 'checkout_date': element.checkout_date
                        });
                      });

                      new_reg_on_visa.forEach(element => {
                        values.push({ 'table_name': 'reg_on_visa', 'reg_visa_id': '0', 
                          'invoice_no': this.invoice_model['invoice_no'],
                          'visa_tax_amount': element.visa_tax_amount, 'country_id': element.country_id,
                          'visa_count': element.visa_count, 'visa_price': this.trip_info['visa_price'], 
                          'visa_cost': element.visa_cost, 'tax_no': element.tax_no, 
                          'tax_type': element.tax_type, 'flag': 'new', 'key': 'reg_visa_id', 
                          'comment': element.comment });
                      });
                    }

                    // if (invoice_info['bed_count']) 
                    // total += Number(this.trip_info['bed_price']) * Number(invoice_info['bed_count']);
        
                    // if (invoice_info['seat_count']) 
                    //   total += Number(this.trip_info['seat_price']) * Number(invoice_info['seat_count']);
                    
                    //------------------------ Extra Amounts, Extra Seats and Extra Beds ------------------------//
                    invoice_item.forEach(element => {
                      // Extra Amounts
                      if (element.type == 'pa') {
                        let ext_amount = Number(element.price), ext_amt_tax = 0;
                        item_discount = 0;
                        if (discount > 0) {
                          if (ext_amount >= discount)
                            item_discount = discount;
                          else 
                            item_discount = ext_amount;
                        }

                        if (this.trip_info['tax_type'] == 'all_price') {
                          if (trip_tax['tax_perc'] != '0') 
                            ext_amt_tax = (ext_amount - item_discount) * (Number(trip_tax['tax_perc']) / 100);
                          else 
                            ext_amt_tax = Number(trip_tax['tax_amount']);
                        }

                        if (discount > 0)
                          discount -= item_discount; 

                        values.push({
                          'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                          'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
                          'sub_item_name': element.sub_item_name, 'price': ext_amount.toFixed(2),
                          'unit_id': '0', 'total_price': ext_amount.toFixed(2), 
                          'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''),
                          'invoice_item_id': '0', 'tax_amount': ext_amt_tax.toFixed(2), 'type': 'pa', 
                          'key': 'invoice_item_id', 'count': '1', 'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0', 
                          'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 'primary_quantity': '0',
                          'comment': element.comment, 'revenue_acct_no': this.invoice_model['sales_acct']
                        });
                      }
                      // Extra Seats
                      else if (element.type == 'ps') {
                        let ext_seat_tax = 0, ext_seat_price = Number(this.trip_info['seat_price']) * Number(invoice_info['seat_count']);
                        item_discount = 0;
                        if (discount > 0) {
                          if (ext_seat_price >= discount)
                            item_discount = discount;
                          else 
                            item_discount = ext_seat_price;

                          discount -= item_discount;
                        }
                      
                        if (this.trip_info['tax_type'] == 'all_price') {
                          if (trip_tax['tax_perc'] != '0') 
                            ext_seat_tax = (ext_seat_price - item_discount) * (Number(trip_tax['tax_perc']) / 100);
                          else 
                            ext_seat_tax = Number(trip_tax['tax_amount']);
                        }

                        values.push({
                          'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                          'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
                          'sub_item_name': element.sub_item_name, 
                          'price': this.trip_info['seat_price'], 'unit_id': '0', 'total_price': ext_seat_price.toFixed(2), 
                          'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
                          'invoice_item_id': '0', 'tax_amount': ext_seat_tax.toFixed(2), 
                          'type': 'ps', 'key': 'invoice_item_id', 'count': this.invoice_model['seat_count'],
                          'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0', 'store_id': this.invoice_model['store_id'], 
                          'primary_sub_item_number': '', 'primary_quantity': '0',
                          'comment': element.comment,
                          'revenue_acct_no': this.invoice_model['sales_acct']
                        });
                      }
                      // Extra Beds
                      else if (element.type == 'pb') {
                        let ext_bed_tax = 0, ext_bed_price = Number(this.trip_info['bed_price']) * Number(invoice_info['bed_count']);
                        item_discount = 0;
                        if (discount > 0) {
                          if (ext_bed_price >= discount)
                            item_discount = discount;
                          else 
                            item_discount = ext_bed_price;

                          discount -= item_discount;
                        }
                        
                        if (this.trip_info['tax_type'] == 'all_price') {
                          if (trip_tax['tax_perc'] != '0') {
                            ext_bed_tax = (ext_bed_price - item_discount) * (Number(trip_tax['tax_perc']) / 100);
                          }
                          else {
                            ext_bed_tax = Number(trip_tax['tax_amount']);
                          }
                        }

                        values.push({
                          'table_name': 'invoice_item', 'invoice_no': this.invoice_model['invoice_no'],
                          'invoice_date': this.invoice_model['invoice_date'], 'sub_item_number': '0',
                          'sub_item_name': element.sub_item_name, 
                          'price': this.trip_info['bed_price'], 'unit_id': '0', 'total_price': ext_bed_price.toFixed(2), 
                          'tax_no': (this.trip_info['tax_type'] == 'all_price' ? this.trip_info['tax_no'] : ''), 
                          'invoice_item_id': '0', 'tax_amount': ext_bed_tax.toFixed(2), 
                          'type': 'pb', 'key': 'invoice_item_id', 'count': this.invoice_model['bed_count'],
                          'flag': 'new', 'discount': item_discount.toFixed(2), 'stock_no': '0',
                          'store_id': this.invoice_model['store_id'], 'primary_sub_item_number': '', 'primary_quantity': '0',
                          'comment': element.comment, 
                          'revenue_acct_no': this.invoice_model['sales_acct']
                        });
                      }
                    });

                    //------------------------ Save ------------------------//
                    let year = this.model['invoice_date'].getFullYear();
                    this.invoice_model['year'] = String(year);

                    let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
                      this.invoice_model['branch_id'] + "'";
                    let prefix = this.invoice_model['branch_id'] + '-' + year + '-';

                    obj = {
                      cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
                      prefix: prefix, idWhere: idWhere
                    };
                    console.log(obj);
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();

                        if (data.status['type'] == 'success') {
                          this.invoice_model['invoice_no'] = data.status['msg'][0]['number'];

                          // return invoice 
                          this.utils.returnSaleInvoice(this.dialog_data, this.model['invoice_date'], this);

                          // this.dialog_data = { 'op_type': 'success' };
                          this.dialogRef.close(this.dialog_data);
                          this.router.navigate(['sub_menu/13/reg_on_trip/' + new_trip_id + '/' + this.invoice_model['invoice_no']]);

                          // alert(this.Success_Msg + this.Inv_No_Msg + this.invoice_model['invoice_no']);
                          // this.router.navigate(['sub_menu/13/tour_invoice_list']);
                        }
                        else 
                          alert(this.Error_Msg);
                      });
                  }
                });
            }
          }
        }
      });

  }

  changeInvoice(trip_group, reg_on_hotel, trip_tax) {
    let invoice_no = this.dialog_data['invoice_no'];

    let values = [];
    let query, obj, toDelete, extraAmount, extraSeat, total_price, tax_amount, sub_item_name;
    let total = 0;
    let total_tax = 0;

    // get invoice item and check the additional amount and additional bus seat 
    query = "SELECT `invoice_item`.* FROM `invoice_item` WHERE `invoice_item`.`invoice_no` = '" +
      invoice_no + "' AND `invoice_item`.`status` = '1'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj, false)
      .subscribe(data => {
        
        let invoice_item_list = data.data['list'];
       
        if (reg_on_hotel.length > 0) {
          reg_on_hotel.forEach(element => {
            total_price = (Number(element.room_price) * Number(element.count) * Number(element.bed_num));
            total += total_price;

            tax_amount = 0;
            if (this.trip_info['tax_type'] == 'all_price') {
              if (trip_tax['tax_perc'] != '0') 
                tax_amount = total_price * (Number(trip_tax['tax_perc']) / 100);
              else 
                tax_amount = Number(trip_tax['tax_amount']);
            }
            total_tax += tax_amount;
            
            sub_item_name = 'غرفة ' + element.room_type + ' على الرحلة ' + 
              this.trip_info['trip_name'] + " (" + this.trip_info['trip_number'] + ")";

            
          });
        }

        invoice_item_list.forEach(element => {
          element.flag = 'delete';
          element.table_name = 'invoice_item';
          toDelete.push(element);

          if (element.type == 'pa') {
            total += Number(element.total_price);
            extraAmount = element;

            if (this.dialog_data['tax_type'] != this.trip_info['tax_type']) {
              extraAmount.tax_no = this.trip_info['tax_no'];
              extraAmount.tax_amount = 0;

              // calculate tax
              if (this.trip_info['tax_type'] == 'all_price') {
                if (trip_tax['tax_perc'] != '0') 
                  extraAmount.tax_amount = extraAmount.total_price * (Number(trip_tax['tax_perc']) / 100);
                else 
                  extraAmount.tax_amount = Number(trip_tax['tax_amount']);
              }
            }
          }
          else if (element.type == 'pb') {
            extraSeat = element;
            extraSeat.price = this.trip_info['seat_price'];
            extraSeat.total_price = Number(this.trip_info['seat_price']) * Number(extraSeat.count);
            
            if (this.dialog_data['tax_type'] != this.trip_info['tax_type']) {
              extraSeat.tax_no = this.trip_info['tax_no'];
              extraSeat.tax_amount = 0;

              // calculate tax
              if (this.trip_info['tax_type'] == 'all_price') {
                if (trip_tax['tax_perc'] != '0') 
                  extraSeat.tax_amount = extraSeat.total_price * (Number(trip_tax['tax_perc']) / 100);
                else 
                  extraSeat.tax_amount = Number(trip_tax['tax_amount']);
              }
            }

            total += Number(element.total_price);
          }
        });

        // invoice detail
        let invoice_detail = this.dialog_data;
        values.push({ 'table_name': 'invoice', 'invoice_id': invoice_detail['invoice_id'], 
          'invoice_no': invoice_detail['invoice_no'], 'invoice_date': invoice_detail['invoice_date'], 
          'trip_id': this.trip_info['trip_id'], 'flag': 'update', 'key': 'invoice_id', 'total': '', 
          'tax': '0', 'tax_acct': this.trip_info['tax_no'] });
      });
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
